import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { BsCalendar, BsClock } from "react-icons/bs";

function ArticleCard({ article }) {
  const navigate = useNavigate();

  const handleReadMore = () => {
    navigate(`/articles/${article.id}`);
  };

  return (
    <Card className="article-card-view">
      <div className="article-card-img-wrap">
        <img
          src={article.coverImage}
          alt={article.title}
          className="article-card-img"
          loading="lazy"
        />
      </div>
      <Card.Body>
        <Card.Title className="article-card-title">{article.title}</Card.Title>
        <Card.Text className="article-card-description">
          {article.description}
        </Card.Text>
        <div className="article-metadata">
          <span className="article-date">
            <BsCalendar /> {new Date(article.date).toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'short', 
              day: 'numeric' 
            })}
          </span>
          <span className="article-read-time">
            <BsClock /> {article.readTime}
          </span>
        </div>
        <div className="article-tags">
          {article.tags.map((tag, index) => (
            <span key={index} className="article-tag">
              {tag}
            </span>
          ))}
        </div>
        <Button 
          variant="primary" 
          onClick={handleReadMore}
          className="article-read-btn"
        >
          Read More →
        </Button>
      </Card.Body>
    </Card>
  );
}

export default ArticleCard;